(() => {
  const rootSelector = 'np-collection';
  const getRoot = (node) => node?.closest(rootSelector);
  const setLoading = (root, value) => {
    const results = root.querySelector('.np-collection-results');
    if (results) results.setAttribute('aria-busy', String(value));
  };
  const closeFilters = (root) => {
    root.querySelector('[data-filter-panel]')?.classList.remove('is-open');
    root.querySelector('[data-filter-toggle]')?.setAttribute('aria-expanded', 'false');
    root.querySelector('[data-filter-backdrop]')?.classList.remove('is-open');
    root.querySelector('.np-filter-backdrop')?.classList.remove('is-open');
  };
  const openFilters = (root) => {
    root.querySelector('[data-filter-panel]')?.classList.add('is-open');
    root.querySelector('[data-filter-toggle]')?.setAttribute('aria-expanded', 'true');
    root.querySelector('.np-filter-backdrop')?.classList.add('is-open');
  };
  const requestUpdate = async (root, targetUrl, push = true) => {
    const sectionId = root.dataset.sectionId;
    const url = new URL(targetUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    setLoading(root, true);
    try {
      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Collection request failed');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector(rootSelector);
      if (!incoming) throw new Error('Collection section was not returned');
      root.replaceWith(incoming);
      if (push) window.history.pushState({ npCollection: true }, '', targetUrl);
      window.scrollTo({ top: document.querySelector('.np-collection-toolbar')?.getBoundingClientRect().top + window.scrollY - 20 || 0, behavior: 'smooth' });
    } catch (error) {
      window.location.href = targetUrl;
    }
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-filter-toggle]');
    if (toggle) { const root = getRoot(toggle); if (root) openFilters(root); return; }
    const closer = event.target.closest('[data-filter-close]');
    if (closer) { const root = getRoot(closer); if (root) closeFilters(root); return; }
    const link = event.target.closest('[data-pagination-link]');
    if (link) { const root = getRoot(link); if (root) { event.preventDefault(); requestUpdate(root, link.href); } }
    const clear = event.target.closest('[data-clear-filters]');
    if (clear) { const root = getRoot(clear); if (root) { event.preventDefault(); requestUpdate(root, clear.href); } }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-filter-form]');
    if (!form) return;
    const root = getRoot(form); if (!root) return;
    event.preventDefault();
    const url = new URL(root.dataset.collectionUrl || window.location.pathname, window.location.origin);
    const data = new FormData(form);
    for (const [key, value] of data.entries()) if (String(value).trim() !== '') url.searchParams.append(key, value);
    const sort = root.querySelector('[data-sort-select]')?.value;
    if (sort) url.searchParams.set('sort_by', sort);
    closeFilters(root); requestUpdate(root, url.toString());
  });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-sort-select]');
    if (!select) return;
    const root = getRoot(select); if (!root) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    requestUpdate(root, url.toString());
  });
  window.addEventListener('popstate', () => {
    const root = document.querySelector(rootSelector);
    if (root) requestUpdate(root, window.location.href, false);
  });
})();
